"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarginPartialCloseError = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const types_1 = require("../types");
const getMarginPartialCloseError = (lots, remainingLots, minimumLots) => {
    /* If the lots is equal to the remaining lots, this is still technically valid. But it should execute a full close instead */
    if ((0, big_1.default)(lots).eq(remainingLots)) {
        return undefined;
    }
    else if ((0, big_1.default)(lots).gt(remainingLots)) {
        return types_1.MarginPartialCloseError.AboveRemainingLots;
    }
    else if ((0, big_1.default)(lots).lt((0, big_1.default)(minimumLots))) {
        return types_1.MarginPartialCloseError.BelowMinimumLots;
    }
    else if ((0, big_1.default)(remainingLots).minus(lots).lt(minimumLots)) {
        return types_1.MarginPartialCloseError.RemainingBelowMinimumLots;
    }
    return undefined;
};
exports.getMarginPartialCloseError = getMarginPartialCloseError;
//# sourceMappingURL=partialClose.js.map